import ErrorGeneral from "components/errors/ErrorGeneral"
import utils from "modules/utils"
import React from "react"

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, showStack: false }

    if (utils.isDev()) {
      this.state.showStack = true
    }
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error }
  }

  componentDidCatch(error, info) {
    // Example "componentStack":
    //   in ComponentThatThrows (created by App)
    //   in ErrorBoundary (created by App)
    //   in div (created by App)
    //   in App
    // logErrorToMyService(error, info.componentStack)
    // console.error(error, info.componentStack)
  }

  render() {
    const { hasError, error } = this.state

    if (hasError) {
      return <ErrorGeneral error={error} />
    }

    return this.props.children
  }
}

export default ErrorBoundary
